import { render, staticRenderFns } from "./LockedGameOverlay.vue?vue&type=template&id=1ddae484&scoped=true&"
import script from "./LockedGameOverlay.vue?vue&type=script&lang=js&"
export * from "./LockedGameOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LockedGameOverlay.vue?vue&type=style&index=0&id=1ddae484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddae484",
  null
  
)

export default component.exports